/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S5_Li5_PostInputs */

const tr_iade_iptal_s5_li5_post = /** @type {(inputs: Iade_Iptal_S5_Li5_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` üzerinden ayrıca değerlendirilir.`)
};

const en_iade_iptal_s5_li5_post = /** @type {(inputs: Iade_Iptal_S5_Li5_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` and are assessed separately.`)
};

const de_iade_iptal_s5_li5_post = /** @type {(inputs: Iade_Iptal_S5_Li5_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` zu richten und werden gesondert geprüft.`)
};

const ru_iade_iptal_s5_li5_post = /** @type {(inputs: Iade_Iptal_S5_Li5_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` и рассматриваются отдельно.`)
};

/**
* | output |
* | --- |
* | "and are assessed separately." |
*
* @param {Iade_Iptal_S5_Li5_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s5_li5_post = /** @type {((inputs?: Iade_Iptal_S5_Li5_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S5_Li5_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s5_li5_post(inputs)
	if (locale === "de") return de_iade_iptal_s5_li5_post(inputs)
	if (locale === "ru") return ru_iade_iptal_s5_li5_post(inputs)
	return tr_iade_iptal_s5_li5_post(inputs)
});